import { createSlice } from '@reduxjs/toolkit';
import { ApprovalCreateNodeType, EApprovalAttribute } from 'api';
const initialState = {
    flowEditor: {
        startNode: {
            id: 'start',
            flowType: ApprovalCreateNodeType.start,
        },
        selectedId: '',
        errors: {},
        baseConfig: {},
        serverConfig: [],
        nodeCount: {
            [ApprovalCreateNodeType.approver]: 0,
            [ApprovalCreateNodeType.condition]: 0,
            [ApprovalCreateNodeType.start]: 0,
        },
        isEdited: false,
        flowId: '',
    },
    approvalCount: {
        [EApprovalAttribute.toApprovalByMe]: 0,
        [EApprovalAttribute.approvedByMe]: 0,
        [EApprovalAttribute.createdByMe]: 0,
    },
};
const slice = createSlice({
    name: 'approvalFlowReducer',
    initialState,
    reducers: {
        selectNode(state, action) {
            state.flowEditor.selectedId = action.payload.id;
        },
        updateNode(state, action) {
            state.flowEditor.startNode = action.payload.newState;
        },
        setErrors(state, action) {
            state.flowEditor.errors = action.payload.errors;
        },
        updateBaseConfig(state, action) {
            state.flowEditor.baseConfig = action.payload.baseConfig;
        },
        updateServerConfig(state, action) {
            state.flowEditor.serverConfig = action.payload.serverConfig;
        },
        initNodeCount(state, action) {
            state.flowEditor.nodeCount = Object.assign(Object.assign({}, state.flowEditor.nodeCount), { [action.payload.ApprovalCreateNodeType]: action.payload.count });
        },
        increaseNodeCount(state, action) {
            state.flowEditor.nodeCount = Object.assign(Object.assign({}, state.flowEditor.nodeCount), { [action.payload.ApprovalCreateNodeType]: state.flowEditor.nodeCount[action.payload.ApprovalCreateNodeType] + 1 });
        },
        decreaseNodeCount(state, action) {
            const result = state.flowEditor.nodeCount[action.payload.ApprovalCreateNodeType] - 1;
            state.flowEditor.nodeCount = Object.assign(Object.assign({}, state.flowEditor.nodeCount), { [action.payload.ApprovalCreateNodeType]: result < 0 ? 0 : result });
        },
        resetCache(state, _) {
            state.flowEditor.baseConfig = {};
            state.flowEditor.serverConfig = [];
            state.flowEditor.startNode = {
                id: 'start',
                flowType: ApprovalCreateNodeType.start,
            };
            state.flowEditor.nodeCount = {
                [ApprovalCreateNodeType.approver]: 0,
                [ApprovalCreateNodeType.condition]: 0,
                [ApprovalCreateNodeType.start]: 0,
            };
            state.flowEditor.isEdited = false;
            state.flowEditor.flowId = '';
        },
        setEdited(state, action) {
            state.flowEditor.isEdited = action.payload.isEdited;
        },
        saveFlowIdForCopy(state, action) {
            state.flowEditor.flowId = action.payload.flowId;
        },
        updateApprovalCount(state, action) {
            const { type, count } = action.payload;
            state.approvalCount = Object.assign(Object.assign({}, state.approvalCount), { [type]: count });
        },
    },
});
export const ApprovalFlowActions = slice.actions;
export default slice.reducer;
